import React from "react";
import UserCreditRequestsComp from "../../components/User/UserCreditRequests";

export default function UserCreditRequests() {
  return <UserCreditRequestsComp />;
}
